import { useEffect } from 'react';
import useGtmResetOnRouteChange from './useGtmResetOnRouteChange';
import gtmDataLayerHandler from '../utils/gtmDataLayerHandler';
var GtmGlobal = function (_a) {
    var route = _a.route, siteName = _a.siteName, mainPlaceholderName = _a.mainPlaceholderName, errorHandler = _a.errorHandler;
    useGtmResetOnRouteChange();
    useEffect(function () {
        gtmDataLayerHandler(route, siteName, mainPlaceholderName, errorHandler);
    }, []);
    return null;
};
export default GtmGlobal;
